module.exports = __webpack_public_path__ + "static/img/download-owner.84aada0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download-owner.png
// module id = L1Mt
// module chunks = 1